import React, { useState } from 'react'

import DateScheduleTable from 'components/common/schedule/DateScheduleTable';
import SessionScheduleTable from 'components/common/schedule/SessionScheduleTable';

import SelectorEvent from 'components/common/selectors/SelectorEvent';
import { useQueries, useQuery, useQueryClient } from 'react-query'
import { getScheduleData, getScheduleDays } from "data/Querys"
import { isValidDate, groupByDate, dateFormat, ALL_URL } from "helpers/utils"
import { InitialDataContext } from 'InitialDataContext';
import { useContext } from 'react';
import Loader from 'components/general/Loader';
import Label from 'components/general/Label';
import NotAvailable from 'components/common/NotAvailable';
import { useViewport } from 'components/general/useViewPort'
import DayList from 'components/common/selector-day/Day';
import SelectorDay from 'components/common/selector-day/SelectorDay';
import 'styles/modules/Schedule.scss';
import PageHeader from 'components/common/PageHeader';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useSelector } from 'react-redux'
import { getGlobalProps } from 'state-management/selectors'
import { useGetConfigSports, useGetDisciplines } from 'helpers/commonCodes';
import { useParams } from 'react-router-dom';
import Moment from 'react-moment';


export async function GetSSR(_discipline, _event) {
    const queryClient = useQueryClient()
    //Query days en memoria     
    await queryClient.prefetchQuery(['scheduleDays', _discipline], getScheduleDays, { staleTime: 180000 });

    const daysData = await queryClient.fetchQuery(
        {
            queryKey: ['scheduleDays', _discipline],
            queryFn: getScheduleDays,
            staleTime: 180000
        });

    //comprobamos que tiene datos sino devolvemos un array vacio
    await Promise.all(daysData?.competition_schedule?.map(async (item, index) => {
        await queryClient.prefetchQuery(
            {
                queryKey: ['scheduleData', 'ATH', item.date, _event],
                queryFn: getScheduleData,
                staleTime: 180000
            });
        //console.log("SSR Date:" + ['scheduleData', 'ATH', item.date, _event])
    })
    )
}

export default function SchedulePage() {

    let params = useUrlFriendlyToParameters()//useParams();
    const data = useGetDisciplines(params);


    //Copy object in order to change 
    let paramsURL = { ...params }

    //let date = "";
    if (!isValidDate(paramsURL['mirs_date'])) {
        //  paramsURL['mirs_date'] = process.env.REACT_APP_DEFAULT_DATE
        paramsURL['mirs_date'] = undefined
    }
    let comp;

    if (paramsURL['mirs_discipline'] === "all-disc") {

        comp = data?.disciplines?.map((item, index) => {
            let paramsURLAux = { ...params }
            paramsURLAux['mirs_discipline'] = item?.code
            return (
                <>
                    <SchedulePageByDiscipline paramsURL={paramsURLAux} allDisc={true} firstElement={index === 0} />
                </>
            )
        })
    } else {
        return <SchedulePageByDiscipline paramsURL={paramsURL} />
    }
    return comp

}

export function SchedulePageByDiscipline({ paramsURL, allDisc, firstElement }) {

    const globalProps = useSelector(getGlobalProps)
    const { breakPoint } = useViewport();

    //*SSR ******************************************/
    const context = useContext(InitialDataContext);

    /* Schedule Days */
    if (context._isServerSide) {
        console.log("Is server side:")
        context._key = ['scheduleDays', paramsURL['mirs_discipline']]
        context._function = getScheduleDays;
        context._data = GetSSR(paramsURL['mirs_discipline'], paramsURL['mirs_event']);
    } else {
        //console.log("NO  server side:")
    }


    const { isError: isErrorScheduleDays, isLoading: isLoadingScheduleDays, data: daysData } = useQuery(
        {
            queryKey: ['scheduleDays', paramsURL['mirs_competition'], paramsURL['mirs_language'], paramsURL['mirs_discipline']],
            queryFn: getScheduleDays,
            refetchInterval: 30000,
            refetchIntervalInBackground: true,
            cacheTime: 300000,
            staleTime: 20000,
            suspense: false,
            notifyOnChangeProps: ['data', 'error']
        });


    let queryArray = [];

    //const params = { 'mirs_competition': paramsURL['mirs_competition'], 'mirs_discipline': paramsURL['mirs_discipline'] };
    const dataConfigSport = useGetConfigSports(paramsURL);

    const isH2H = dataConfigSport?.isH2H;

    daysData?.competition_schedule?.forEach((item) => {
        queryArray.push({
            queryKey: ['scheduleData', paramsURL['mirs_competition'], paramsURL['mirs_language'], paramsURL['mirs_discipline'], item.date, paramsURL['mirs_event'], isH2H],
            queryFn: getScheduleData,
            refetchInterval: 30000,
            refetchIntervalInBackground: true,
            //cacheTime: 300000,
            //staleTime: 0,
            suspense: false,
            notifyOnChangeProps: ['data', 'error']
        })
    })


    const results = useQueries(queryArray);
    const isLoading = context._isSSRDraw ? false : isLoadingScheduleDays || results.some(result => result.isLoading)
    const isError = context._isSSRDraw ? false : isErrorScheduleDays || results.some(result => result.isError)
    //const isLogers = context._isSSRDraw ? false : results.some(result => result.data ? result.data.loggerMirs : '')
    const allSuccess = context._isSSRDraw ? true : results.every(result => result.isSuccess === true)

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader /> }

    if (allSuccess) {
        //we need to filter by phase type
        //const results = results.data.filter((d) => u.eventUnit.phase.type.match('[13]') )            

        //All data from days 
        let items = []
        results && results.map((item, index) => {
            const data = item.data.filter((u) => u?.eventUnit?.phase?.type?.match('[13]'))
            items.push(...data)
        })

        //filters by event
        if (paramsURL['mirs_event'] !== undefined && paramsURL['mirs_event'] !== ALL_URL.ALL_EVENT) {
            items = items?.filter(row => row?.eventUnit?.phase?.event?.code === paramsURL['mirs_event'])
        }

        //Group data by days whit timezone, structure object day in key , schedules by day in value
        let dates = groupByDate(items, 'startDate', globalProps.timezone);


        //Create Object as data from getScheduleDays in order to use in SelectorDay,DayList
        let itemsDates = { competition_schedule: [] }
        for (const [key, value] of Object.entries(dates)) {
            itemsDates.competition_schedule.push({ date: key })
        }

        //Get diferents components 
        let arr = []
        for (const [key, value] of Object.entries(dates)) {
            const day = key
            const discipline = value[0]?.discipline?.code
            const eventorder = value[0]?.discipline?.eventorder
            let schedule = null

            switch (eventorder) {
                case 'DATE':
                case 'LOC':
                    schedule = <DateScheduleTable data={value} eventorder={eventorder} key={`schedule-${discipline}-${day}`} />
                    break;
                case 'SESSION':
                    schedule = <SessionScheduleTable data={value} key={`schedule-${discipline}-${day}`} />
                    break;
                default:
                    schedule = <DateScheduleTable data={value} eventorder={eventorder} key={`schedule-${discipline}-${day}`} />
                    break;
            }



            //filter by day if is necessary 
            if (isValidDate(paramsURL['mirs_date'])) {
                if (paramsURL['mirs_date'] === dateFormat(key)) {
                    //console.log(dateFormat(key))
                    arr.push(schedule)
                }
            } else {
                arr.push(schedule)
            }
        }



        return (
            <>
                {allDisc && firstElement && <>
                    <PageHeader title={
                        <><Label data="MenuSchedules" />
                            &nbsp;-&nbsp;<Moment tz={globalProps.timeZone} format="DD MMMM">
                                {paramsURL['mirs_date']}
                            </Moment></>
                    } />

                </>}
                {!allDisc && <PageHeader title={<Label data="MenuSchedules" />} />}
                {
                    (breakPoint === "md" || breakPoint === "sm" || breakPoint === "xs")
                        ? !allDisc && <SelectorDay daysItems={itemsDates} />
                        : !allDisc && <DayList daysItems={itemsDates} />
                }

                {!allDisc && <div className="selectors-container">
                    <SelectorEvent page='schedule' />
                </div>}

                {arr}
            </>
        );




        /*
                return (
                    <>
                        <PageHeader title={<Label data="MenuSchedules" />} />
                        {
                            (breakPoint === "md" || breakPoint === "sm" || breakPoint === "xs")
                                ? <SelectorDay daysItems={daysData} />
                                : <DayList daysItems={daysData} />
                        }
                        <SelectorEvent />
                        {
                            results && results.map((item, index) => {
                                const day = item.data[0]?.startDate
                                const discipline = item.data[0]?.discipline?.code
                                const eventorder = item.data[0]?.discipline?.eventorder
                                let schedule = null
                                if (day === undefined)
                                    return null //no data
                                switch (eventorder) {
                                    case 'DATE':
                                    case 'LOC':
                                        schedule = <DateScheduleTable data={item.data} eventorder={eventorder} key={`schedule-${discipline}-${day}`} />
                                        break;
                                    case 'SESSION':
                                        schedule = <SessionScheduleTable data={item.data} key={`schedule-${discipline}-${day}`} />
                                        break;
                                    default:
                                        schedule = <DateScheduleTable data={item.data} eventorder={eventorder} key={`schedule-${discipline}-${day}`} />
                                        break;
                                }
                                return schedule
                            })
                        }
                    </>
                );
        */


    }
}


export function SchedulePage2() {
    let params = useUrlFriendlyToParameters()//useParams();

    return (
        <h2>{params['mirs_discipline']}</h2>
    )
}




